import { render, staticRenderFns } from "./select-local.vue?vue&type=template&id=3d1b63a2&scoped=true&"
import script from "./select-local.vue?vue&type=script&lang=js&"
export * from "./select-local.vue?vue&type=script&lang=js&"
import style0 from "./select-local.vue?vue&type=style&index=0&id=3d1b63a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1b63a2",
  null
  
)

export default component.exports